module.exports = __webpack_public_path__ + "media/images/ticket_02-232a9be82cc14d4406c6dc515cee7765.png";